// Fragment "platform operator access" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/NoAccess.jsx (the shared no-access panel), the role shown in the
// SuperAdminLayout header and the role / status names on the Team screen. Role names are read
// by role KEY (backend/rbac.py PLATFORM_ROLES), never from the server's English `role_label`.
export default {
  fr: {
    "access.deniedTitle": "Vous n'avez pas accès à cette page",
    "access.deniedBody": "Votre rôle ne donne pas accès à cet écran. Demandez à un Super-Admin si vous en avez besoin.",
    "access.forbiddenAction": "Vous n'avez pas la permission de faire cela.",
    "team.role.super_admin": "Super-Admin",
    "team.role.finance": "Finance",
    "team.role.support": "Support",
    "team.role.viewer": "Lecture seule",
    "team.status.active": "Actif",
    "team.status.suspended": "Suspendu",
    "team.inviteLocale": "Langue de l'invitation",
    "team.inviteLocale.fr": "Français",
    "team.inviteLocale.en": "English",
    "team.inviteLocale.es": "Español",
    "team.memberAddedEmailed": "Membre ajouté. Une invitation a été envoyée à {email}.",
    "team.memberAddedEmailPending": "Membre ajouté. L'invitation à {email} n'est pas encore remise ; elle est en file d'attente et sera renvoyée automatiquement.",
    "team.memberAddedEmailNotSent": "Membre ajouté, mais l'invitation à {email} n'a pas pu être envoyée. Prévenez cette personne qu'elle a accès.",
    "team.byConfiguration": "Par configuration",
    "team.byConfigurationHint": "Adresse Super-Admin par configuration du serveur (SUPER_ADMIN_EMAILS ou SUPER_ADMIN_DOMAINS). Le rôle choisi ici s'applique ; la retirer de l'équipe la garde suspendue, car sans fiche la configuration lui redonnerait tous les accès.",
    "team.confirmRemoveConfigured": "{email} est Super-Admin par configuration du serveur. Sans fiche d'équipe, cette adresse retrouverait tous les accès : elle restera dans l'équipe, suspendue. Continuer ?",
    "team.memberRemovedKeptSuspended": "Accès retiré. {email} reste dans l'équipe, suspendu, car la configuration du serveur lui redonnerait tous les accès.",
    "team.lastAdministrator": "Impossible : l'équipe n'aurait plus aucun Super-Admin actif capable de la gérer. Donnez d'abord cet accès à un autre membre.",
    "team.rosterBusy": "Une autre modification de l'équipe est en cours. Réessayez.",
  },
  en: {
    "access.deniedTitle": "You don't have access to this page",
    "access.deniedBody": "Your role doesn't include this screen. Ask a Super-Admin if you need it.",
    "access.forbiddenAction": "You don't have permission to do this.",
    "team.role.super_admin": "Super-Admin",
    "team.role.finance": "Finance",
    "team.role.support": "Support",
    "team.role.viewer": "Read only",
    "team.status.active": "Active",
    "team.status.suspended": "Suspended",
    "team.inviteLocale": "Invitation language",
    "team.inviteLocale.fr": "Français",
    "team.inviteLocale.en": "English",
    "team.inviteLocale.es": "Español",
    "team.memberAddedEmailed": "Member added. An invitation was emailed to {email}.",
    "team.memberAddedEmailPending": "Member added. The invitation to {email} is not delivered yet; it is queued and retried automatically.",
    "team.memberAddedEmailNotSent": "Member added, but the invitation to {email} could not be sent. Let them know they have access.",
    "team.byConfiguration": "By configuration",
    "team.byConfigurationHint": "A Super-Admin address by server configuration (SUPER_ADMIN_EMAILS or SUPER_ADMIN_DOMAINS). The role picked here applies; removing it from the team keeps it suspended, because without a team row the configuration would give it full access again.",
    "team.confirmRemoveConfigured": "{email} is a Super-Admin by server configuration. Without a team row this address would get full access back, so it will stay on the team, suspended. Continue?",
    "team.memberRemovedKeptSuspended": "Access removed. {email} stays on the team, suspended, because the server configuration would give it full access again.",
    "team.lastAdministrator": "Not possible: the team would be left without an active Super-Admin who can manage it. Give another member that access first.",
    "team.rosterBusy": "Another team change is in progress. Try again.",
  },
  es: {
    "access.deniedTitle": "No tienes acceso a esta página",
    "access.deniedBody": "Tu rol no incluye esta pantalla. Pídeselo a un Super-Admin si lo necesitas.",
    "access.forbiddenAction": "No tienes permiso para hacer esto.",
    "team.role.super_admin": "Super-Admin",
    "team.role.finance": "Finanzas",
    "team.role.support": "Soporte",
    "team.role.viewer": "Solo lectura",
    "team.status.active": "Activo",
    "team.status.suspended": "Suspendido",
    "team.inviteLocale": "Idioma de la invitación",
    "team.inviteLocale.fr": "Français",
    "team.inviteLocale.en": "English",
    "team.inviteLocale.es": "Español",
    "team.memberAddedEmailed": "Miembro añadido. Se envió una invitación a {email}.",
    "team.memberAddedEmailPending": "Miembro añadido. La invitación a {email} aún no se ha entregado; está en cola y se reintentará automáticamente.",
    "team.memberAddedEmailNotSent": "Miembro añadido, pero no se pudo enviar la invitación a {email}. Avísale de que ya tiene acceso.",
    "team.byConfiguration": "Por configuración",
    "team.byConfigurationHint": "Dirección Super-Admin por configuración del servidor (SUPER_ADMIN_EMAILS o SUPER_ADMIN_DOMAINS). Se aplica el rol elegido aquí; quitarla del equipo la mantiene suspendida, porque sin ficha la configuración le devolvería acceso total.",
    "team.confirmRemoveConfigured": "{email} es Super-Admin por configuración del servidor. Sin ficha de equipo, esta dirección recuperaría acceso total, así que seguirá en el equipo, suspendida. ¿Continuar?",
    "team.memberRemovedKeptSuspended": "Acceso retirado. {email} sigue en el equipo, suspendido, porque la configuración del servidor le devolvería acceso total.",
    "team.lastAdministrator": "No es posible: el equipo quedaría sin ningún Super-Admin activo que pueda gestionarlo. Da primero ese acceso a otro miembro.",
    "team.rosterBusy": "Hay otro cambio del equipo en curso. Inténtalo de nuevo.",
  },
};
